import { Controller } from "@hotwired/stimulus"
import ahoy from 'ahoy.js'
import { format } from "date-fns"

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.export)
  }

  disconnect() {
    this.element.removeEventListener("click", this.export)
  }

  export = (event) => {
    event.preventDefault()

    const tableSelector = this.element.dataset.target
    if (!tableSelector) {
      alert("No target attribute found")
      return
    }

    const table = document.querySelector(tableSelector)
    if (!table) {
      alert(`No table found for selector: ${tableSelector}`)
      return
    }
    this.downloadTableAsCSV(table)
    ahoy.track("CSV Table Export", { selector: tableSelector })
  }

  downloadTableAsCSV(table, separator = ",") {
    const rows = table.querySelectorAll("tr")
    const csv = []

    rows.forEach(row => {
      const cols = row.querySelectorAll("td, th")
      const rowData = []

      cols.forEach(col => {
      let data = col.innerText
        .replace(/(\r\n|\n|\r)/gm, " ")   // turn newlines into spaces
        .replace(/\s\s+/g, " ")           // collapse multiple spaces
        .trim()
        data = data.replace(/"/g, '""')
        rowData.push(`"${data}"`)
      })

      csv.push(rowData.join(separator))
    })

    const csvString = csv.join("\n")
    const nowAsNumber = format(new Date(), "yyyyMMdd_HHmmss")
    const tableName = (table.id || "table").replaceAll('-','_')
    const filename = `export_${ tableName }_${ nowAsNumber }.csv`

    const link = document.createElement("a")
    link.style.display = "none"
    link.setAttribute("href", "data:text/csv;charset=utf-8," + encodeURIComponent(csvString))
    link.setAttribute("download", filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
